export const toTestIdSegment = (value: string) => value.toLowerCase().replaceAll("_", "-")
